(ns frontend.test.new-components
  (:require [frontend.routing :as routing]
            [basic-components.inputs.all]
            [basic-components.inputs.footprint :refer [editor viewer]]
            [basic-components.field-editor :as field-editor]
            [basic-components.tabstrip-v2 :as tabstrip]
            [reagent.core :as r]
            [frontend.utils :as fu]
            [basic-components.attachments :as attachments]
            [basic-components.email-content :as email-content]
            [basic-components.step-indicator :as step-indicator]))

(defn sample-step-one []
  [:span "Step 1"])
(defn sample-step-two []
  [:span
   [:h3 "Step 2"]
   [:span "step 2/2"]])
(defn sample-step-three []
  [:strong "step 3"])

(defn sample-step-indicator []
  (let [state (r/atom {})
        current-step :test-step-1
        steps [{:key     :test-step-1
                :content [sample-step-one]}
               {:key     :test-step-2
                :content [sample-step-two]}
               {:key     :test-step-3
                :content [sample-step-three]}]]
    [:div
     [:h2.title-h2.mb-2 "Step indicator"]
     [step-indicator/view {:state        state
                           :current-step current-step
                           :steps        steps}]]))

(defn sample-email-content []
  (let [from "test@zapflow.com"
        to "test123@zapflow.com"
        cc "abc@zapflow.com"
        subject "New test email"
        body "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."]
    [:div.mb-3
     [:h2.title-h2.mb-2 "Email Content"]
     [email-content/view {:from    from
                          :to      to
                          :cc      cc
                          :subject subject
                          :body    body}]]))

(defn sample-attachments []
  (let [state (r/atom {})
        attachments [{:lower-case-entity         {:attachment/filename     "small-example-pdf-file.pdf",
                                                  :db/id                   17592186156877,
                                                  :attachment/content-type "application/pdf"}
                      :common/tenant             17592186046184
                      :common/created-on         1618210665463
                      :common/updated-on         1618210665463
                      :attachment/created        1618210665463
                      :entity/type               :entity.type/attachment
                      :attachment/content-length 4107
                      :attachment/filename       "small-example-pdf-file.pdf"
                      :db/id                     17592186156877
                      :attachment/content-type   "application/pdf"}]]
    [:div.mb-3
     [:h2.title-h2 "Attachments"]
     [attachments/view {:state       state
                        :attachments attachments}]]))

(defn sample-tabstrip []
  (let [default-tab :tab-1
        state (r/atom {:selected-tab :tab-5})]
    (fn []
      [:div.mb-4
       [:h2.title-h2 "Tabstrip"]
       [:div.resizable
        [tabstrip/component {:on-change!       (fn [new-tab-key]
                                                 (swap! state assoc :selected-tab new-tab-key))
                             :selected-tab-key (or (:selected-tab @state) default-tab)
                             :tab-strip-id     "sample-tabs-1"
                             :tabs             (->> (range 0 50)
                                                    (map (fn [idx]
                                                           {:tab-key   (keyword "tab" (str idx))
                                                            :tab-label (str "Tab " idx)}))
                                                    (doall))}]
        (str (:selected-tab @state))
        ]])))

(defn sample-textarea []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2 "Textarea"]

       [:h3.title-h3.mt-4.mb-3 "Field editor mode"]
       [field-editor/view
        {:editor/type              :editor.type/textarea
         :value                    (:value @state)
         :state-atom               state
         :attribute                :test-textarea-attribute
         :label                    "Textarea"
         :hide-label?              false
         :on-save!                 (fn [v]
                                     (swap! state assoc :value v))
         :class-name               "zap-textarea"
         :mandatory?               false
         :field/label-icon-tooltip "Tooltip text here"
         :field/label-icon         :fa-question-circle
         :drag-options             nil
         :validate!                (fn []
                                     true)
         :disabled?                false
         :constraints-max          1000
         :read-only?               false
         :field/tooltip-right      "Textarea"
         :error-text               "Test error text"
         :secondary-view-args      nil}]])))

(defn sample-input-text []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4 "Input text"]
       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/text-simple
                :value       "Input text"}]

       [:h4.title-h3.mt-4.mb-3 "Editor mode"]
       [editor {:editor/type :editor.type/text-simple
                :state-atom  state
                :value       (:value @state)
                :placeholder "placeholder"
                :on-change!  (fn [e new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb-3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/text-simple
         :class-name          (fu/cs "")
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-input-attribute
         :label               "Input type text"
         :hide-label?         false
         :on-save!            (fn [new-value]
                                (swap! state assoc :value new-value))
         :on-change           (fn [new-value]
                                (swap! state assoc :value new-value))
         :mandatory?          true
         :draggable?          true
         :drag-options        {:draggable? true}
         :disabled?           false
         :read-only?          false
         :info-text           "Info text"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))

(defn sample-checkbox []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.my-4 "Checkbox"]

       #_[:h3.title-h3.my-3 "Read mode"]
       #_[viewer {:editor/type :editor.type/checkbox
                  :value       "Checkbox value"}]

       [:h4.title-h3.mt-4.mb-3 "A form can contain checkboxes"]
       [:div.mb-3
        [editor {:editor/type   :editor.type/checkbox
                 :state-atom    state
                 :checkbox-text "Default checkbox"
                 :value         (:value @state)
                 :on-change!    (fn [e checked?]
                                  (swap! state assoc :value checked?))}]]

       [:div.mb-3
        [editor {:editor/type   :editor.type/checkbox
                 :state-atom    state
                 :checkbox-text "Checked checkbox"
                 :value         true
                 :on-change!    (fn [e checked?]
                                  (swap! state assoc :checked-value checked?))}]]

       [:div.mb-3
        [editor {:editor/type   :editor.type/checkbox
                 :state-atom    state
                 :checkbox-text "Disabled checkbox"
                 :value         (:disabled-value @state)
                 :disabled?     true
                 :on-change!    (fn [e checked?]
                                  (swap! state assoc :disabled-value checked?))}]]

       #_[:h3.title-h3.mt-4.mb-3 "Field editor mode"]
       #_[field-editor/view
          {:editor/type         :editor.type/checkbox
           :value               (:value @state)
           :state-atom          state
           :attribute           :test-textarea-attribute
           :label               "Test Checkbox"
           :hide-label?         false
           :on-save!            (fn [v]
                                  (swap! state assoc :value v))
           :class-name          ""
           :mandatory?          true
           :drag-options        nil
           :validate!           (fn []
                                  true)
           :disabled?           false
           :read-only?          false
           :info-text           "Info Checkbox"
           :error-text          "Test error text"
           :tools               [:tool-item/clear
                                 :tool-item/copy
                                 :tool-item/save
                                 :tool-item/cancel]
           :secondary-view-args nil}]
       ])))

(defn sample-radio []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4 "Radio"]

       [:h4.title-h3.mt-4.mb-3 "Editor mode"]
       [editor {:editor/type :editor.type/radio
                :state-atom  state
                :options     [{:key   :key-1
                               :label "Radio 1"}
                              {:key   :key-2
                               :label "Radio 2"}
                              {:key   :key-3
                               :label "Radio 3"}]
                :value       (:value @state)
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]
       ])))

(defn sample-toggle []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4.mb-2 "Toggle"]

       #_[:h3.title-h3.my-3 "Read mode"]
       #_[viewer {:editor/type :editor.type/toggle
                  :value       "toggle value"}]
       [:div.custom-switches
        [:h3.title-h3.mt-2 "On .custom-switch"]
        [editor {:editor/type       :editor.type/toggle
                 :state-atom        state
                 :custom-class-name "custom-switch"
                 :toggle-on-text    ""
                 :toggle-off-text   ""
                 :value             true
                 :on-change!        (fn [e checked?]
                                      (swap! state assoc :value checked?))}]

        [:h3.title-h3.mt-2 "Off .custom-switch"]
        [editor {:editor/type       :editor.type/toggle
                 :state-atom        state
                 :custom-class-name "custom-switch"
                 :toggle-on-text    ""
                 :toggle-off-text   ""
                 :value             false
                 :on-change!        (fn [e checked?]
                                      (swap! state assoc :value checked?))}]

        [:h3.title-h3.mt-2 "Disabled .custom-switch"]
        [editor {:editor/type       :editor.type/toggle
                 :state-atom        state
                 :custom-class-name "custom-switch"
                 :toggle-on-text    ""
                 :toggle-off-text   ""
                 :disabled?         true
                 :value             true
                 :on-change!        (fn [e checked?]
                                      (swap! state assoc :value checked?))}]]


       #_[:h3.title-h3.mt-4.mb-3 "Field editor mode"]
       #_[field-editor/view
          {:editor/type         :editor.type/toggle
           :value               (:value @state)
           :state-atom          state
           :attribute           :test-textarea-attribute
           :label               "Test toggle"
           :hide-label?         false
           :on-save!            (fn [v]
                                  (swap! state assoc :value v))
           :class-name          ""
           :mandatory?          true
           :drag-options        nil
           :validate!           (fn []
                                  true)
           :disabled?           false
           :read-only?          false
           :info-text           "Info toggle"
           :error-text          "Test error text"
           :tools               [:tool-item/clear
                                 :tool-item/copy
                                 :tool-item/save
                                 :tool-item/cancel]
           :secondary-view-args nil}]])))

(defn sample-select []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4.mb-3 "Select"]

       [:p "Read mode"]
       [viewer {:editor/type :editor.type/select
                :value       "Select"}]

       [:h4.title-h3.mt-4.mb-3 "Editor mode"]
       [:div.select-area
        [editor {:editor/type :editor.type/select
                 :state-atom  state
                 :options     [{:key   :key-1
                                :label "Select 1"}
                               {:key   :key-2
                                :label "Select 2"}
                               {:key   :key-3
                                :label "Select 3"}]
                 :value       (:value @state)
                 :on-change!  (fn [e value]
                                (swap! state assoc :value value))}]]


       [:h4.title-h3.mt-4.mb-3 "Field editor mode"]
       [:div.select-area
        [field-editor/view
         {:editor/type         :editor.type/select
          :value               (:value @state)
          :state-atom          state
          :attribute           :test-select-attribute
          :label               "Select"
          :hide-label?         false
          :on-save!            (fn [v]
                                 (swap! state assoc :value v))
          :class-name          ""
          :mandatory?          true
          :drag-options        nil
          :validate!           (fn []
                                 true)
          :disabled?           false
          :read-only?          false
          :info-text           "Info Select"
          :error-text          "Test error text"
          :tools               [:tool-item/clear
                                :tool-item/copy
                                :tool-item/save
                                :tool-item/cancel]
          :secondary-view-args nil}]]

       [:h4.title-h3.mt-4.mb-3 "Search mode"]
       [:div.select-area
        [field-editor/view
         {:editor/type         :editor.type/select
          :value               (:value @state)
          :state-atom          state
          :attribute           :test-select-attribute
          :label               "Search select"
          :hide-label?         false
          :on-save!            (fn [v]
                                 (swap! state assoc :value v))
          :class-name          "search"
          :mandatory?          true
          :drag-options        nil
          :validate!           (fn []
                                 true)
          :options             [{:key   :key-1
                                 :label "Select 1"}
                                {:key   :key-2
                                 :label "Select 2"}
                                {:key   :key-3
                                 :label "Select 3"}]
          :disabled?           false
          :read-only?          false
          :info-text           "Info Select"
          :error-text          "Test error text"
          :tools               [:tool-item/clear
                                :tool-item/copy
                                :tool-item/save
                                :tool-item/cancel]
          :secondary-view-args nil}]]])))

(defn sample-multi-select []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4 "Multi select"]

       [:h3.title-h3.my-3 "Read mode"]
       [:div.select-area
        [viewer {:editor/type :editor.type/multi-select
                 :value       "Multiselect value"}]]

       [:h4.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/multi-select
                :state-atom  state
                :value       (:value @state)
                :options     [{:key   :key-1
                               :label "Select 1"}
                              {:key   :key-2
                               :label "Select 2"}
                              {:key   :key-3
                               :label "Select 3"}
                              {:key   :key-4
                               :label "Select 4"}
                              {:key   :key-5
                               :label "Select 5"}
                              {:key   :key-6
                               :label "Select 6"}]
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]

       [:h3.title-h3.mt-4.mb-3 "Field editor mode"]
       [:div.select-area
        [field-editor/view
         {:editor/type         :editor.type/multi-select
          :value               (:value @state)
          :state-atom          state
          :attribute           :test-textarea-attribute
          :label               "Multi select"
          :hide-label?         false
          :on-save!            (fn [v]
                                 (swap! state assoc :value v))
          :class-name          ""
          :mandatory?          true
          :drag-options        nil
          :validate!           (fn []
                                 true)
          :disabled?           false
          :read-only?          false
          :info-text           "Info multi select"
          :error-text          "Test error text"
          :tools               [:tool-item/clear
                                :tool-item/copy
                                :tool-item/save
                                :tool-item/cancel]
          :secondary-view-args nil}]]])))

(defn sample-email []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4 "Email"]

       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/email
                :value       "name@email.com"}]

       [:h3.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/email
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [e value]
                               (swap! state assoc :value value))}]

       [:h4.title-h3.mt-4.mb-3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/email
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-select-attribute
         :label               "Email"
         :hide-label?         false
         :on-save!            (fn [v]
                                (swap! state assoc :value v))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn []
                                true)
         :disabled?           false
         :read-only?          false
         :info-text           "Info Email"
         :error-text          "Test error email"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))


(defn sample-multiplier []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2 "Multiplier"]

       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/multiplier
                :value       "Multiplier"}]

       [:h4.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/multiplier
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/multiplier
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-textarea-attribute
         :label               "Multiplier"
         :hide-label?         false
         :on-save!            (fn [v]
                                (swap! state assoc :value v))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn []
                                true)
         :disabled?           false
         :read-only?          false
         :info-text           "Info multiplier"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))

(defn sample-integer []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2 "Integer"]

       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/integer
                :value       "Integer"}]

       [:h4.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/integer
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/integer
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-textarea-attribute
         :label               "Integer"
         :hide-label?         false
         :on-save!            (fn [v]
                                (swap! state assoc :value v))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn []
                                true)
         :disabled?           false
         :read-only?          false
         :info-text           "Info Integer"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))

(defn sample-percentage []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2 "Percentage"]

       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/percentage
                :value       "Integer"}]

       [:h4.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/percentage
                :placeholder "percentage"
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/percentage
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-textarea-attribute
         :label               "Integer"
         :hide-label?         false
         :on-save!            (fn [v]
                                (swap! state assoc :value v))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn []
                                true)
         :disabled?           false
         :read-only?          false
         :info-text           "Info Integer"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))

(defn sample-related-entities []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2 "Related-entities"]

       [:h3.title-h3.my-3 "Read mode"]
       [viewer {:editor/type :editor.type/related-entities
                :value       "Related entities"}]

       [:h4.title-h3.mt-4 "Editor mode"]
       [editor {:editor/type :editor.type/related-entities
                :state-atom  state
                :value       (:value @state)
                :on-change!  (fn [new-value]
                               (swap! state assoc :value new-value))}]

       [:h4.title-h3.mt-4.mb3 "Field editor mode"]
       [field-editor/view
        {:editor/type         :editor.type/related-entities
         :value               (:value @state)
         :state-atom          state
         :attribute           :test-textarea-attribute
         :label               "Integer"
         :hide-label?         false
         :on-save!            (fn [v]
                                (swap! state assoc :value v))
         :class-name          ""
         :mandatory?          true
         :drag-options        nil
         :validate!           (fn []
                                true)
         :disabled?           false
         :read-only?          false
         :info-text           "Info Integer"
         :error-text          "Test error text"
         :tools               [:tool-item/clear
                               :tool-item/copy
                               :tool-item/save
                               :tool-item/cancel]
         :secondary-view-args nil}]])))


(defmethod routing/render-view :test/new-components [{:keys [route-params]}]
  [:div.container.bg-white.scroll
   [:h1.title-h1.mb-4 "New components"]
   [:div.mb-4
    [sample-email-content]
    [sample-step-indicator]]
   [:ul
    [:li [sample-tabstrip]]
    [:li [sample-textarea]]
    [:li [sample-input-text]]
    [:li [sample-checkbox]]
    [:li [sample-toggle]]
    [:li [sample-radio]]
    [:li [sample-select]]
    [:li [sample-multi-select]]
    [:li [sample-email]]
    [:li [sample-multiplier]]
    [:li [sample-integer]]
    [:li [sample-percentage]]
    [:li [sample-related-entities]]
    ]])
